(function() {
  var STORAGE_KEY = "mtggoldfish.cardTray.v1";
  var VERSION = 1;
  var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  var MAX_UNIQUE = 200;
  var MAX_TOTAL = 1000;
  var SAFE_AREA_CANDIDATE_SELECTOR = [
    "[id^='ad' i]",
    "[id*='-ad' i]",
    "[id*='_ad' i]",
    "[id*='ad-' i]",
    "[id*='ad_' i]",
    "[class^='ad' i]",
    "[class*=' ad' i]",
    "[class*='-ad' i]",
    "[class*='_ad' i]",
    "[class*='ad-' i]",
    "[class*='ad_' i]",
    "[id*='anchor' i]",
    "[class*='anchor' i]",
    "[id*='banner' i]",
    "[class*='banner' i]",
    "[id*='bottom' i]",
    "[class*='bottom' i]",
    "[id*='sticky' i]",
    "[class*='sticky' i]",
    "[style*='fixed' i]"
  ].join(",");
  var state = {
    items: [],
    view: "list",
    validating: false,
    validationQueued: false,
    revision: 0
  };

  function csrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta && meta.content;
  }

  function trayElement() {
    return document.getElementById("card-tray");
  }

  function endpoints() {
    var el = trayElement();
    if (!el) return {};
    return {
      validate: el.dataset.cardTrayValidateUrl,
      decklist: el.dataset.cardTrayDecklistUrl,
      collection: el.dataset.cardTrayCollectionUrl,
      card_kingdom: el.dataset.cardTrayCardKingdomUrl,
      tcgplayer: el.dataset.cardTrayTcgplayerUrl
    };
  }

  function loadState() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
      var rawItems = parsed && parsed.version === VERSION && Array.isArray(parsed.items) ? parsed.items : [];
      state.items = rawItems.map(function(item) {
        return {
          card_uuid: String(item.card_uuid || "").trim(),
          quantity: positiveQuantity(item.quantity)
        };
      }).filter(function(item) {
        return UUID_RE.test(item.card_uuid);
      }).slice(0, MAX_UNIQUE);
      enforceTotalLimit();
    } catch (_) {
      state.items = [];
    }
  }

  function saveState() {
    var items = state.items.map(function(item) {
      return { card_uuid: item.card_uuid, quantity: item.quantity };
    });
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ version: VERSION, items: items }));
      return true;
    } catch (_) {
      return false;
    }
  }

  function touchState() {
    state.revision += 1;
  }

  function positiveQuantity(value) {
    var quantity = parseInt(value, 10);
    if (!Number.isFinite(quantity) || quantity < 1) return 1;
    return quantity;
  }

  function totalQuantity() {
    return state.items.reduce(function(sum, item) { return sum + positiveQuantity(item.quantity); }, 0);
  }

  function enforceTotalLimit() {
    var runningTotal = 0;
    state.items = state.items.filter(function(item) {
      runningTotal += item.quantity;
      return runningTotal <= MAX_TOTAL;
    });
  }

  function showMessage(message, type) {
    var el = document.querySelector(".card-tray-message");
    if (!el) return;
    el.textContent = message || "";
    el.className = "card-tray-message alert";
    el.classList.add(type === "error" ? "alert-danger" : "alert-success");
    el.classList.toggle("d-none", !message);
  }

  function clearMessage() {
    showMessage("", "success");
  }

  function safeImageUrl(url) {
    if (!url) return null;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return null;
      return parsed.toString();
    } catch (_) {
      return null;
    }
  }

  function itemTitle(item) {
    return item.display_name || item.card_uuid;
  }

  function titleize(value) {
    return String(value || "")
      .split(/[-_\s]+/)
      .filter(Boolean)
      .map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }

  function finishLabel(item) {
    if (!item.finish || item.finish === "regular") return null;
    if (item.finish_label) return item.finish_label;
    if (item.finish === "foil") return "Foil";
    if (item.finish === "foil_etched") return "Foil-Etched";
    if (String(item.finish).indexOf("foil") === -1) return null;
    return titleize(item.finish);
  }

  function appendBadge(parent, className, text) {
    if (!text) return;
    if (parent.childNodes.length > 0) {
      parent.appendChild(document.createTextNode(" "));
    }
    var badge = document.createElement("span");
    badge.className = className;
    badge.textContent = text;
    parent.appendChild(badge);
  }

  function renderItemMeta(meta, item) {
    if (item.set) {
      meta.appendChild(document.createTextNode(item.set));
    }
    appendBadge(meta, "card-num", item.card_num ? "#" + item.card_num : null);

    var tags = Array.isArray(item.tags) ? item.tags : [];
    var tagLabels = Array.isArray(item.tag_labels) ? item.tag_labels : [];
    tags.forEach(function(tag, index) {
      appendBadge(meta, "badge badge-variation", tagLabels[index] || titleize(tag));
    });

    var hasFoilTag = tags.some(function(tag) {
      return tag === "foil" || String(tag).endsWith("-foil");
    });
    var finish = finishLabel(item);
    if (!hasFoilTag && finish) {
      var className = item.finish === "foil" || item.finish === "foil_etched" ? "badge badge-foil" : "badge badge-variation";
      appendBadge(meta, className, finish);
    }
  }

  function bindCardTrayPopover(link, item, imageUrl) {
    if (!imageUrl || !window.bootstrap || !window.bootstrap.Popover) return;
    link.setAttribute("rel", "popover");
    link.dataset.fullImage = imageUrl;
    link.dataset.cardId = item.card_id || itemTitle(item);
    window.bootstrap.Popover.getOrCreateInstance(link, {
      content: "<div class='popover-image'><img src='" + imageUrl.replace(/'/g, "&#39;") + "'></div>",
      delay: { show: 200, hide: 0 },
      trigger: "hover",
      placement: "right",
      html: true,
      template: '<div class="popover-card popover"><div class="popover-arrow"></div><div class="popover-body"></div></div>'
    });
  }

  function renderItem(item) {
    var row = document.createElement("div");
    row.className = "card-tray-item";

    function imagePlaceholder() {
      var placeholder = document.createElement("div");
      placeholder.className = "card-tray-item-image";
      placeholder.setAttribute("aria-hidden", "true");
      return placeholder;
    }

    var imageUrl = item.validated ? safeImageUrl(item.image_url) : null;
    var image = imagePlaceholder();
    if (imageUrl) {
      image = document.createElement("img");
      image.className = "card-tray-item-image";
      image.src = imageUrl;
      image.alt = itemTitle(item);
      image.addEventListener("error", function() {
        image.replaceWith(imagePlaceholder());
      }, { once: true });
    }
    row.appendChild(image);

    var listQuantity = document.createElement("span");
    listQuantity.className = "card-tray-list-qty";
    listQuantity.textContent = item.quantity + "x";
    row.appendChild(listQuantity);

    var body = document.createElement("div");
    var title = document.createElement("div");
    title.className = "card-tray-item-title";
    if (item.links && item.links.default) {
      var link = document.createElement("a");
      link.href = item.links.default;
      link.textContent = itemTitle(item);
      bindCardTrayPopover(link, item, imageUrl);
      title.appendChild(link);
    } else {
      title.textContent = itemTitle(item);
    }
    body.appendChild(title);

    var meta = document.createElement("div");
    meta.className = "card-tray-item-meta";
    renderItemMeta(meta, item);
    body.appendChild(meta);
    row.appendChild(body);

    var actions = document.createElement("div");
    actions.className = "card-tray-item-actions";
    actions.dataset.cardUuid = item.card_uuid;

    var controls = document.createElement("div");
    controls.className = "card-tray-item-controls";
    controls.dataset.cardUuid = item.card_uuid;

    var decrement = document.createElement("button");
    decrement.type = "button";
    decrement.className = "btn btn-outline-secondary";
    decrement.textContent = "-";
    decrement.setAttribute("aria-label", "Decrease quantity");
    decrement.dataset.cardTrayQuantity = "decrement";
    controls.appendChild(decrement);

    var quantity = document.createElement("span");
    quantity.className = "card-tray-item-qty";
    quantity.textContent = item.quantity;
    controls.appendChild(quantity);

    var increment = document.createElement("button");
    increment.type = "button";
    increment.className = "btn btn-outline-secondary";
    increment.textContent = "+";
    increment.setAttribute("aria-label", "Increase quantity");
    increment.dataset.cardTrayQuantity = "increment";
    controls.appendChild(increment);

    var remove = document.createElement("button");
    remove.type = "button";
    remove.className = "btn btn-link card-tray-item-remove";
    remove.setAttribute("aria-label", "Remove card");
    remove.dataset.cardTrayQuantity = "remove";
    var removeIcon = document.createElement("span");
    removeIcon.className = "fa fa-trash";
    removeIcon.setAttribute("aria-hidden", "true");
    remove.appendChild(removeIcon);

    actions.appendChild(controls);
    actions.appendChild(remove);
    row.appendChild(actions);
    return row;
  }

  function render() {
    var itemsEl = document.querySelector(".card-tray-items");
    var emptyEl = document.querySelector(".card-tray-empty");
    var footerEl = document.querySelector(".card-tray-footer");
    var bodyActionsEl = document.querySelector(".card-tray-body-actions");
    if (!itemsEl || !emptyEl) return;

    updateTextZoomClass();
    itemsEl.replaceChildren();
    itemsEl.classList.toggle("card-tray-grid", state.view === "grid");
    updateViewButtons();
    state.items.forEach(function(item) {
      itemsEl.appendChild(renderItem(item));
    });

    var itemCount = state.items.length;
    var quantityCount = totalQuantity();
    document.querySelectorAll(".card-tray-toggle-count").forEach(function(countEl) {
      countEl.textContent = quantityCount;
    });
    document.querySelectorAll(".card-tray-item-count").forEach(function(countEl) {
      countEl.textContent = itemCount;
    });
    document.querySelectorAll(".card-tray-total-quantity").forEach(function(countEl) {
      countEl.textContent = quantityCount;
    });
    document.querySelectorAll(".card-tray-total-label").forEach(function(labelEl) {
      labelEl.textContent = quantityCount === 1 ? "card total" : "cards total";
    });
    emptyEl.classList.toggle("d-none", state.items.length > 0);
    if (footerEl) footerEl.classList.remove("d-none");
    if (bodyActionsEl) bodyActionsEl.classList.remove("d-none");
    updateActionAvailability(state.items.length > 0);
    updateImageAddButtons();
  }

  function updateActionAvailability(hasItems) {
    document.querySelectorAll("[data-card-tray-action]").forEach(function(button) {
      button.disabled = !hasItems;
      button.setAttribute("aria-disabled", hasItems ? "false" : "true");
    });
    document.querySelectorAll(".card-tray-collect .dropdown-toggle").forEach(function(button) {
      button.disabled = !hasItems;
      button.setAttribute("aria-disabled", hasItems ? "false" : "true");
    });
  }

  function updateViewButtons() {
    document.querySelectorAll("[data-card-tray-view]").forEach(function(button) {
      var active = button.dataset.cardTrayView === state.view;
      button.classList.toggle("active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function updateTextZoomClass() {
    var el = trayElement();
    if (!el || !window.getComputedStyle) return;
    var rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
    el.classList.toggle("card-tray-text-zoom", Number.isFinite(rootFontSize) && rootFontSize >= 24);
  }

  function isTraySafeAreaCandidate(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.id === "card-tray" || el.id === "card-tray-toggle") return false;
    if (el.closest("#card-tray, #card-tray-toggle, .modal, .offcanvas, .popover, .tooltip, .toast")) return false;

    var style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden" || Number(style.opacity) === 0) return false;
    if (style.position !== "fixed") return false;

    var rect = el.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (rect.height < 24 || rect.width < Math.min(280, viewportWidth * 0.45)) return false;
    if (rect.top < viewportHeight * 0.5) return false;
    if (rect.bottom < viewportHeight - 16 || rect.top > viewportHeight - 24) return false;

    return true;
  }

  function likelyTraySafeAreaElement(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.id === "card-tray" || el.id === "card-tray-toggle") return false;
    if (el.closest("#card-tray, #card-tray-toggle, .modal, .offcanvas, .popover, .tooltip, .toast")) return false;
    if (!el.matches) return false;
    return el.matches(SAFE_AREA_CANDIDATE_SELECTOR);
  }

  function findTraySafeAreaCandidates() {
    if (!document.body || !document.body.querySelectorAll) return [];
    return Array.prototype.filter.call(
      document.body.querySelectorAll(SAFE_AREA_CANDIDATE_SELECTOR),
      likelyTraySafeAreaElement
    );
  }

  function traySafeAreaObservedElements() {
    if (!window.__mtgCardTraySafeAreaObservedElements) {
      window.__mtgCardTraySafeAreaObservedElements = new Set();
    }
    return window.__mtgCardTraySafeAreaObservedElements;
  }

  function traySafeAreaResizeObserver() {
    if (!window.ResizeObserver) return null;
    if (!window.__mtgCardTraySafeAreaResizeObserver) {
      window.__mtgCardTraySafeAreaResizeObserver = new ResizeObserver(scheduleBottomSafeAreaUpdate);
    }
    return window.__mtgCardTraySafeAreaResizeObserver;
  }

  function observeTraySafeAreaCandidate(el) {
    var observer = traySafeAreaResizeObserver();
    if (!observer) return;

    var observed = traySafeAreaObservedElements();
    if (observed.has(el)) return;

    observed.add(el);
    observer.observe(el);
  }

  function unobserveTraySafeAreaCandidate(el) {
    var observer = window.__mtgCardTraySafeAreaResizeObserver;
    var observed = traySafeAreaObservedElements();
    if (!observed.has(el)) return;

    observed.delete(el);
    if (observer) observer.unobserve(el);
  }

  function nodeOrDescendantWasObserved(node) {
    if (!node || node.nodeType !== 1) return false;
    var observed = traySafeAreaObservedElements();
    if (observed.has(node)) return true;
    if (!node.querySelectorAll) return false;

    return Array.prototype.some.call(node.querySelectorAll("*"), function(descendant) {
      return observed.has(descendant);
    });
  }

  function reconcileTraySafeAreaObservers(candidates) {
    var observed = traySafeAreaObservedElements();
    observed.forEach(function(el) {
      if (!document.documentElement.contains(el) || !likelyTraySafeAreaElement(el)) {
        unobserveTraySafeAreaCandidate(el);
      }
    });
    candidates.forEach(observeTraySafeAreaCandidate);
  }

  function mutationMayAffectBottomSafeArea(mutation) {
    if (mutation.type === "attributes") {
      return likelyTraySafeAreaElement(mutation.target) || nodeOrDescendantWasObserved(mutation.target);
    }

    var nodes = Array.prototype.concat.call(
      Array.prototype.slice.call(mutation.addedNodes || []),
      Array.prototype.slice.call(mutation.removedNodes || [])
    );

    return nodes.some(function(node) {
      if (!node || node.nodeType !== 1) return false;
      if (likelyTraySafeAreaElement(node)) return true;
      if (nodeOrDescendantWasObserved(node)) return true;
      return !!(node.querySelector && node.querySelector(SAFE_AREA_CANDIDATE_SELECTOR));
    });
  }

  function updateBottomSafeArea() {
    if (!window.getComputedStyle) return;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var maxOverlap = 0;
    var candidates = findTraySafeAreaCandidates();
    reconcileTraySafeAreaObservers(candidates);
    candidates.forEach(function(el) {
      if (!isTraySafeAreaCandidate(el)) return;
      var rect = el.getBoundingClientRect();
      maxOverlap = Math.max(maxOverlap, Math.ceil(Math.max(0, viewportHeight - rect.top)));
    });

    var offset = maxOverlap > 0 ? maxOverlap + 12 : 0;
    document.documentElement.style.setProperty("--card-tray-bottom-safe-area", offset + "px");
  }

  function scheduleBottomSafeAreaUpdate() {
    window.clearTimeout(window.__mtgCardTraySafeAreaTimer);
    window.__mtgCardTraySafeAreaTimer = window.setTimeout(updateBottomSafeArea, 50);
  }

  function cardIsInTray(cardUuid) {
    return state.items.some(function(item) { return item.card_uuid === cardUuid; });
  }

  function updateImageAddButtons() {
    document.querySelectorAll(".card-tray-image-add[data-card-tray-card-action='add']").forEach(function(button) {
      var card = button.closest("[data-card-tray-card]");
      var cardUuid = card && card.dataset.cardUuid;
      var inTray = cardIsInTray(cardUuid);
      var label = button.getAttribute("aria-label");
      var cardName = button.dataset.cardTrayDisplayName || label && label.replace(/^Add\s+/, "").replace(/(?:\s+to Card Tray|\s+is in Card Tray)+$/, "");
      button.classList.toggle("is-in-tray", inTray);
      button.textContent = inTray ? "\u2713 In Tray" : "+ Tray";
      if (cardName) {
        button.setAttribute("aria-label", inTray ? cardName + " is in Card Tray" : "Add " + cardName + " to Card Tray");
      }
    });
  }

  function pulseTrayToggle() {
    var toggle = document.getElementById("card-tray-toggle");
    if (!toggle) return;
    toggle.classList.remove("card-tray-toggle-feedback");
    void toggle.offsetWidth;
    toggle.classList.add("card-tray-toggle-feedback");
    window.clearTimeout(toggle.cardTrayFeedbackTimer);
    toggle.cardTrayFeedbackTimer = window.setTimeout(function() {
      toggle.classList.remove("card-tray-toggle-feedback");
    }, 900);
  }

  function openTray() {
    var el = trayElement();
    if (!el || !window.bootstrap || !window.bootstrap.Offcanvas) return;
    window.bootstrap.Offcanvas.getOrCreateInstance(el).show();
  }

  function addCard(cardUuid, quantity) {
    if (!UUID_RE.test(cardUuid || "")) {
      showMessage("This card cannot be added because it is missing a card UUID.", "error");
      return false;
    }

    var existing = state.items.find(function(item) { return item.card_uuid === cardUuid; });
    if (existing) {
      existing.quantity += positiveQuantity(quantity);
    } else {
      if (state.items.length >= MAX_UNIQUE) {
        showMessage("Card Tray can contain at most " + MAX_UNIQUE + " unique cards.", "error");
        return false;
      }
      state.items.push({ card_uuid: cardUuid, quantity: positiveQuantity(quantity) });
    }

    if (totalQuantity() > MAX_TOTAL) {
      existing ? existing.quantity -= positiveQuantity(quantity) : state.items.pop();
      showMessage("Card Tray can contain at most " + MAX_TOTAL + " total cards.", "error");
      return false;
    }

    touchState();
    saveState();
    render();
    validateTray();
    return true;
  }

  function adjustQuantity(cardUuid, mode) {
    var item = state.items.find(function(candidate) { return candidate.card_uuid === cardUuid; });
    if (!item) return;
    if (mode === "increment") {
      if (totalQuantity() >= MAX_TOTAL) {
        showMessage("Card Tray can contain at most " + MAX_TOTAL + " total cards.", "error");
        return;
      }
      item.quantity += 1;
    } else if (mode === "decrement") {
      item.quantity -= 1;
      if (item.quantity <= 0) {
        state.items = state.items.filter(function(candidate) { return candidate.card_uuid !== cardUuid; });
      }
    } else if (mode === "remove") {
      state.items = state.items.filter(function(candidate) { return candidate.card_uuid !== cardUuid; });
    }
    touchState();
    saveState();
    render();
    validateTray();
  }

  function requestJson(url, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken() || ""
      },
      body: JSON.stringify(body || {})
    }).then(function(response) {
      return response.text().then(function(text) {
        var json = {};
        try {
          json = text ? JSON.parse(text) : {};
        } catch (_) {
          if (response.redirected && response.url) {
            window.location.href = response.url;
          }
          throw new Error(response.redirected ? "Please log in to use this Card Tray action." : "Card Tray request failed.");
        }

        if (!response.ok) {
          throw new Error(json.error || "Card Tray request failed.");
        }
        return json;
      });
    });
  }

  function trayPayload() {
    return { items: state.items.map(function(item) { return { card_uuid: item.card_uuid, quantity: item.quantity }; }) };
  }

  function validateTray() {
    var urls = endpoints();
    if (!urls.validate || state.items.length === 0) return Promise.resolve();
    if (state.validating) {
      state.validationQueued = true;
      return Promise.resolve();
    }
    state.validating = true;
    state.validationQueued = false;
    var requestRevision = state.revision;
    return requestJson(urls.validate, trayPayload()).then(function(json) {
      var validatedByUuid = {};
      (json.items || []).forEach(function(item) {
        item.validated = true;
        item.quantity = positiveQuantity(item.quantity);
        validatedByUuid[item.card_uuid] = item;
      });
      if (state.revision === requestRevision) {
        state.items = (json.items || []).map(function(item) {
          item.validated = true;
          item.quantity = positiveQuantity(item.quantity);
          return item;
        });
      } else {
        state.items = state.items.map(function(item) {
          var validatedItem = validatedByUuid[item.card_uuid];
          if (!validatedItem) return item;
          return Object.assign({}, validatedItem, { quantity: item.quantity });
        });
      }
      saveState();
      clearMessage();
      render();
    }).catch(function(error) {
      showMessage(error.message, "error");
    }).finally(function() {
      state.validating = false;
      if (state.validationQueued && state.items.length > 0) {
        validateTray();
      }
    });
  }

  function clearTray() {
    state.items = [];
    touchState();
    saveState();
    clearMessage();
    render();
  }

  function runAction(action, trigger) {
    var urls = endpoints();
    if (action === "clear") {
      clearTray();
      return;
    }
    if (state.items.length === 0) {
      showMessage("Card Tray is empty.", "error");
      return;
    }

    var body = trayPayload();
    if (action === "decklist") {
      var nameInput = document.querySelector(".card-tray-name-input");
      if (nameInput) {
        body.name = nameInput.value;
      }
    } else if (action === "collection") {
      var typeSelect = document.querySelector(".card-tray-collection-type");
      body.type = trigger && trigger.dataset.cardTrayCollectionType || typeSelect && typeSelect.value;
    }

    requestJson(urls[action], body).then(function(json) {
      if (json.redirect_url) {
        window.location.href = json.redirect_url;
      } else if (json.url) {
        window.location.href = json.url;
      } else {
        showMessage(json.message || "Card Tray action completed.", "success");
      }
    }).catch(function(error) {
      showMessage(error.message, "error");
    });
  }

  function bindEvents() {
    if (window.__mtgCardTrayClickHandler) {
      document.removeEventListener("click", window.__mtgCardTrayClickHandler);
    }

    window.__mtgCardTrayClickHandler = function(event) {
      var cardAction = event.target.closest("[data-card-tray-card-action]");
      if (cardAction) {
        var card = cardAction.closest("[data-card-tray-card]");
        if (!card) return;
        event.preventDefault();
        if (cardAction.dataset.cardTrayCardAction !== "add") return;
        if (cardAction.classList.contains("card-tray-image-add") && cardIsInTray(card.dataset.cardUuid)) {
          openTray();
          return;
        }
        if (addCard(card.dataset.cardUuid, 1)) {
          pulseTrayToggle();
        }
        return;
      }

      var quantityAction = event.target.closest("[data-card-tray-quantity]");
      if (quantityAction) {
        event.preventDefault();
        var controls = quantityAction.closest("[data-card-uuid]");
        adjustQuantity(controls && controls.dataset.cardUuid, quantityAction.dataset.cardTrayQuantity);
        return;
      }

      var action = event.target.closest("[data-card-tray-action]");
      if (action) {
        event.preventDefault();
        if (action.disabled) return;
        runAction(action.dataset.cardTrayAction, action);
        return;
      }

      var view = event.target.closest("[data-card-tray-view]");
      if (view) {
        event.preventDefault();
        state.view = view.dataset.cardTrayView === "grid" ? "grid" : "list";
        render();
      }
    };

    document.addEventListener("click", window.__mtgCardTrayClickHandler);

    if (window.__mtgCardTrayResizeHandler) {
      window.removeEventListener("resize", window.__mtgCardTrayResizeHandler);
    }
    window.__mtgCardTrayResizeHandler = function() {
      updateTextZoomClass();
      scheduleBottomSafeAreaUpdate();
    };
    window.addEventListener("resize", window.__mtgCardTrayResizeHandler);

    if (window.__mtgCardTrayMutationObserver) {
      window.__mtgCardTrayMutationObserver.disconnect();
    }
    if (window.__mtgCardTraySafeAreaResizeObserver) {
      window.__mtgCardTraySafeAreaResizeObserver.disconnect();
      delete window.__mtgCardTraySafeAreaResizeObserver;
    }
    if (window.__mtgCardTraySafeAreaObservedElements) {
      window.__mtgCardTraySafeAreaObservedElements.clear();
    }
    if (window.MutationObserver && document.body) {
      window.__mtgCardTrayMutationObserver = new MutationObserver(function(mutations) {
        if (mutations.some(mutationMayAffectBottomSafeArea)) {
          scheduleBottomSafeAreaUpdate();
        }
      });
      window.__mtgCardTrayMutationObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ["class", "id", "style"],
        childList: true,
        subtree: true
      });
    }
  }

  function init() {
    if (!trayElement()) return;
    loadState();
    render();
    bindEvents();
    updateBottomSafeArea();
    validateTray();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
